import { Grid, GridColumn } from "@progress/kendo-react-grid";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { parseIcons } from "../../Utils/parseIcons";
import { AlertRequest } from "../Alerts/Buy";
import { onRequestOffer } from "../../Utils/requestOffer";
import { markFavorite } from "../../Utils/markFavorite";
import { DataContext } from "../../App";
import { Button } from "@progress/kendo-react-buttons";
import { Images } from "../../Utils/logos";
import { FAVMESSAGE } from "../../Utils/variables";
import "./PolicyList.css";
import "./PolicyTable.css";
import parseCoveragesInTable from "../../Utils/parseCoveragesInTable";

var formatter = new Intl.NumberFormat("es-CO", {
  style: "currency",
  currency: "COP",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

const fontSize = "11pt";

const transposeDataAgnostic = (data, parsedCoverages) => {
  const prices = {};
  const manufacturers = {};
  const id_dbs = {};
  const newData = [
    { name: "logo" },
    { name: "Datos principales", type: "group" },
    { name: "Nombre de Producto" },
    { name: "Precio" },
    { name: "Valor Asegurado" },
    { name: "Válido hasta" },
    ...parsedCoverages,
  ];
  data.map((item, index) => {
    prices[index] = formatter.format(item.price);
    manufacturers[index] = item.manufacturer;
    id_dbs[index] = item.id_db;
    newData[0][index] = item.logo;
    newData[2][index] = item.name
      .toLowerCase()
      .replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());
    newData[3][index] = item.priceString;
    newData[4][index] = formatter.format(item.amount_quoted);
    newData[5][index] = item.offer_expiration_date;
  });
  return [newData, prices, manufacturers, id_dbs];
};

const rowRender = (trElement, props) => {
  const type = props.dataItem.type;
  const group = {
    backgroundColor: "#acacac72",
    color: "var(--table-color)",
  };

  const defaultStyle = {
    backgroundColor: "#fff",
    borderBottom: "1px solid #eee",
    width: "100%",
    padding: "0.5em",
    color: "#3c4858",
  };

  const trProps = {
    colSpan: "6",
    style: type === "group" ? group : defaultStyle,
    width: "100%",
  };
  const childrens =
    type === "group" ? (
      <React.Fragment>
        <td
          colSpan={props.children.length <= 3 ? props.children.length : 2}
          className="table-title"
        >
          <span>{props.dataItem.name}</span>
        </td>
        {props.children.length > 3 ? (
          <td colSpan={props.children.length - 2} className="table-title"></td>
        ) : null}
      </React.Fragment>
    ) : (
      props.children
    );

  return React.cloneElement(trElement, { ...trProps }, childrens);
};

export default function PolicyTable({ data, toPrint, origin }) {
  const { context } = React.useContext(DataContext);
  const policies = React.useMemo(
    () =>
      data.policy_list?.map((item) => {
        item.products[0].amount_quoted = item.amount_quoted;
        item.products[0].offer_expiration_date = item.offer_expiration_date;
        item.products[0].id_db = item.id_db;
        item.products[0].favorite = item.favorite;
        item.products[0].view_status = item.view_status;
        item.products[0].policy_provider = item.provider;
        item.products[0].total_price_anual = item.total_price_anual;

        if (item.price_type == "prorrateado") {
          var priceString = (
            <table style={{ maxWidth: "245px", margin: "auto" }}>
              <tbody
                style={window.innerWidth < 1170 ? { display: "block" } : {}}
              >
                <tr
                  style={window.innerWidth < 1170 ? { display: "block" } : {}}
                >
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                            backgroundColor: "#eee",
                          }
                        : { padding: "0 0 0 10px", textAlign: "left" }
                    }
                  >
                    Prorrata:
                  </td>
                  <td
                    colSpan={1}
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: 0,
                            display: "block",
                            width: "100%",
                          }
                        : { textAlign: "right", padding: "0 10px 0 0" }
                    }
                  >
                    <span style={{ color: "#09f", fontSize: "1em" }}>
                      {" "}
                      <strong>{formatter.format(item.total_price)}</strong>
                    </span>
                  </td>
                </tr>
                <tr
                  style={window.innerWidth < 1170 ? { display: "block" } : {}}
                >
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                            backgroundColor: "#eee",
                          }
                        : { padding: "0 0 0 10px", textAlign: "left" }
                    }
                  >
                    Cobertura hasta:
                  </td>
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                          }
                        : { padding: "0 10px 0 0", textAlign: "right" }
                    }
                  >
                    {item.end_date}
                  </td>
                </tr>
                <tr
                  style={window.innerWidth < 1170 ? { display: "block" } : {}}
                >
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                            backgroundColor: "#eee",
                          }
                        : { padding: "0 0 0 10px", textAlign: "left" }
                    }
                  >
                    Días de vigencia:
                  </td>
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                          }
                        : { padding: "0 10px 0 0", textAlign: "right" }
                    }
                  >
                    {item.duration_days}
                  </td>
                </tr>
                <tr
                  style={window.innerWidth < 1170 ? { display: "block" } : {}}
                >
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                            backgroundColor: "#eee",
                          }
                        : { padding: "0 0 0 10px", textAlign: "left" }
                    }
                  >
                    Anual:
                  </td>
                  <td
                    style={
                      window.innerWidth < 1170
                        ? {
                            textAlign: "center",
                            padding: "0",
                            display: "block",
                            width: "100%",
                          }
                        : { padding: "0 10px 0 0", textAlign: "right" }
                    }
                  >
                    {formatter.format(item.total_price_anual)}
                  </td>
                </tr>
              </tbody>
            </table>
          );

          item.products[0].priceString = priceString;
        } else {
          item.products[0].priceString = (
            <span style={{ color: "#09f", fontSize: "1em" }}>
              <strong>{formatter.format(item.total_price)}</strong>
            </span>
          );
        }

        return item.products[0];
      }),
    [data.policy_list]
  );

  const [getDataTranspose] = React.useState(
    transposeDataAgnostic(
      policies,
      parseCoveragesInTable(policies, context.groups)
    )
  );

  const [dataTranspose] = React.useState(getDataTranspose[0]);

  const [pricesTranspose] = React.useState(getDataTranspose[1]);

  const [manufacturersTranspose] = React.useState(getDataTranspose[2]);

  const [id_dbsTranspose] = React.useState(getDataTranspose[3]);

  const Logo = (props) => {
    return (
      <div className="text-center bg-white w-100 h-100">
        {dataTranspose[0][props.field] ? (
          <React.Fragment>
            <img
              className="mx-auto"
              style={{ height: "80px", width: "auto", display: "block" }}
              src={Images[manufacturersTranspose[props.field].toLowerCase()]}
              alt={manufacturersTranspose[props.field]}
            />
            {policies[props.field].view_status == "Recomendada" ||
            policies[props.field].view_status == 1 ? (
              <div className="ribbon-card">
                <span className="ribbon-message">Recomendado</span>
              </div>
            ) : null}
            {/* <span className="table-price" style={{ display: "block" }}>
              {pricesTranspose[props.field]}
            </span> */}
            {origin === "comparative" && (
              <>
                {policies[props.field].favorite ? (
                  <div className="fav-message-container">
                    <span className="fav-message">{FAVMESSAGE}</span>
                  </div>
                ) : (
                  <Button
                    className="sec-button"
                    style={{ fontSize: "0.9em", padding: "0.3em 0.6em" }}
                    onClick={() => {
                      onRequestOffer(context, id_dbsTranspose[props.field]);
                    }}
                  >
                    Solicitar
                  </Button>
                )}
              </>
            )}
          </React.Fragment>
        ) : (
          <span></span>
        )}
      </div>
    );
  };

  const Group = (props) => {
    return (
      <React.Fragment>
        {props.dataItem.type === "group" ? (
          <React.Fragment>
            <td></td>
          </React.Fragment>
        ) : (
          <td
            style={{
              borderBottom: "1px solid #eee",
              left: 0,
              right: 0,
              borderRight: "none",
              fontSize: fontSize,
            }}
            className={"bg-white w-100 h-100 " + props.className}
          >
            <span>{props.dataItem[props.field]}</span>
          </td>
        )}
      </React.Fragment>
    );
  };

  function replaceURL(message) {
    if (!message) return;

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    const match = urlRegex.exec(message);
    if (!match)
      return <span dangerouslySetInnerHTML={{ __html: message }}></span>;

    return (
      <>
        <span
          dangerouslySetInnerHTML={{ __html: message.slice(0, match.index) }}
        ></span>
        <a className="redirect-quote-click" href={match[0]} target="_blank">
          {match[0]}
        </a>
      </>
    );
  }

  const PropertyCell = (props) => {
    return (
      <td
        style={{
          borderTop: "none",
          borderBottom: "1px solid #eee",
          borderLeft: "none",
          borderRight: "none",
          paddingTop: "0em",
          paddingBottom: "0em",
          fontSize: fontSize,
          verticalAlign: Array.isArray(props.dataItem[props.field])
            ? "baseline"
            : "",
        }}
        className="text-center"
      >
        {Array.isArray(props.dataItem[props.field]) ? (
          <ul
            style={{
              textAlign: "left",
              paddingInlineStart: policies.length + 6 + "px",
            }}
          >
            {props.dataItem[props.field].map((el, idx) => (
              <li key={idx}>{replaceURL(el)}</li>
            ))}
          </ul>
        ) : (
          <span>
            {parseIcons[props.dataItem[props.field] || "NO"]
              ? parseIcons[props.dataItem[props.field] || "NO"]
              : props.dataItem[props.field] || "NO"}
          </span>
        )}
      </td>
    );
  };
  const grid = (
    <Grid
      style={{
        // maxHeight: toPrint ? null : "100vh",
        // maxHeight:"800px",
        // height:"80%",
        minWidth: "100%",
        fontSize: fontSize,
        // overflow: "hidden",
        scrollTop: 1,
      }}
      className="mx-auto"
      headerCellRender={Logo}
      reorderable={true}
      rowRender={rowRender}
      data={dataTranspose.slice(1)}
    >
      <GridColumn
        field="name"
        width={170}
        locked={true}
        title="Atributo"
        cell={Group}
      />
      {policies.map((item, index) => {
        return (
          <GridColumn
            key={index}
            headerCell={Logo}
            cell={PropertyCell}
            width={170}
            field={index.toString()}
          />
        );
      })}
    </Grid>
  );

  return (
    <Row className="col-row-correction">
      <Col xs={12} className="col-row-correction" style={{ padding: 0 }}>
        {grid}
      </Col>
    </Row>
  );
}
